// extracted by mini-css-extract-plugin
module.exports = {"Heading":"HomeActivityFeed_Heading__h3R_i","scrollToTopButton":"HomeActivityFeed_scrollToTopButton__C77kT"};